export const track = (event, properties = {}) => {
  window.analytics?.track(event, properties);
};
